import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
const routes = {
  forwardContract: '/contract-shared/shared',
  consumptionHistory: '/analysis/consumption'
};

@Injectable({
  providedIn: 'root'
})
export class ForwardContractService {

  constructor(private apiService: ApiService) {
  }

    // update luồng ký nội bộ của bên nhận
    forwardContract(data) {
      return this.apiService.post(routes.forwardContract, data)
        .pipe(map(res => {
          return res;
        }));
    }
}
